'use client';

import dynamic from 'next/dynamic';

export const FoldingDemo = dynamic(() => import('./FoldingDemo'));
export const TheTrickDemo = dynamic(() => import('./TheTrickDemo'));
export const FoldTransformDemo = dynamic(
  () => import('./FoldTransformDemo')
);
export const FoldPerspectiveDemo = dynamic(
  () => import('./FoldPerspectiveDemo')
);
export const FoldOriginDemo = dynamic(
  () => import('./FoldOriginDemo')
);
export const FoldCodeSnippet = dynamic(
  () => import('./FoldCodeSnippet')
);
